export class SalesOrg {

    public id: string;
    public source: string;
    public name: string;
}
